export enum SchedulerStatus {
  Scheduled = 1,
  Rescheduled = 2,
  Cancelled = 3,
}
